<div class="notification-bell">
  <button
    #notificationBtn
    type="button"
    class="notification-bell__trigger"
    (click)="toggle($event)"
    [attr.aria-label]="'TFNotification.Notifications' | translate">
    <i-feather name="bell" [title]="'TFNotification.Notifications' | translate"></i-feather>
    <span class="notification-bell__counter" *ngIf="unreadCount > 0">{{ unreadCount }}</span>
  </button>

  <app-notification-generic
    [notifications]="popupList"
    [isOpen]="isOpen"
    [viewAllRoute]="viewAllRoute"
    [triggerButtonRef]="notificationBtn"
    (close)="close()"
    (viewAllClick)="close()"
    (markAllAsReadClick)="markAllAsRead()"
    (notificationClick)="onNotificationClick($event)">
  </app-notification-generic>
</div>
